import { render, staticRenderFns } from "./BoxMaterialEdit.vue?vue&type=template&id=7ba8df22&"
import script from "./BoxMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./BoxMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports